import { Link } from 'react-router-dom';

export default function FeaturesCTA() {
  return (
    <section className="py-24 px-6 bg-gray-950">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 bg-teal-900/40 border border-teal-800/50 rounded-full px-4 py-1.5 mb-6">
          <i className="ri-plane-line text-teal-400 text-xs" />
          <span className="text-xs font-medium text-teal-400 uppercase tracking-wider">Ready to automate?</span>
        </div>
        <h2 className="text-3xl md:text-4xl font-semibold text-white leading-tight tracking-tight mb-5">
          Your Agency Deserves to Work<br />
          <span className="bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent">Smarter, Not Harder</span>
        </h2>
        <p className="text-gray-400 text-base leading-relaxed mb-8 max-w-xl mx-auto">
          From the first WhatsApp message to the post-trip review — TreWaz handles it all. Start your free trial today. No credit card required.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <Link
            to="/register"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-500 to-emerald-500 text-white text-sm font-semibold px-7 py-3.5 rounded-lg hover:from-teal-600 hover:to-emerald-600 transition-all cursor-pointer whitespace-nowrap"
          >
            Start Free Trial
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 border border-gray-700 text-gray-400 text-sm font-medium px-7 py-3.5 rounded-lg hover:border-teal-700 hover:text-teal-400 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-3-line" />
            Back to Home
          </Link>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-6 text-gray-600">
          {[
            { icon: 'ri-shield-check-line', label: 'No credit card required' },
            { icon: 'ri-time-line', label: '14-day free trial' },
            { icon: 'ri-customer-service-2-line', label: 'Onboarding included' },
            { icon: 'ri-lock-2-line', label: 'Cancel anytime' },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-1.5">
              <i className={`${item.icon} text-teal-600 text-sm`} />
              <span className="text-xs">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
